import { OptionKey } from '@/common/types';
import { DetailedBy, GroupByFilter, PlanYearReportFilterItems } from '@/modules/Reports/report.types';
import { LAST_4_DIGIT_KEY } from '@/modules/Reports/report.types';
import { storeCreator } from '@/utils/store/store.utils';

export type forfeitureGroupByType = [GroupByFilter | null, GroupByFilter | null];

export const FORFEITURE_GROUP_BY_PLAN_YEAR: OptionKey[] = [PlanYearReportFilterItems.NULL];

export const FORFEITURE_GROUP_BY_DEFAULT_VALUE: OptionKey = GroupByFilter.Partner;

interface State {
  search: string;
  planYear: OptionKey[];
  groupBy: OptionKey;
  SSNOption: OptionKey;
  detailedBy: DetailedBy;
  handleSetSSNOption: (value: OptionKey) => void;
  handleSetSearch: (value: string) => void;
  handleSetDetailedBy: (value: DetailedBy) => void;
  handleSetPlanYear: (value: OptionKey[]) => void;
  handleSetGroupBy: (groupBy: OptionKey) => void;
  handleClear: () => void;
}

export const useForfeitureReportFilterStore = storeCreator<State>((set) => ({
  detailedBy: DetailedBy.TRANSACTION,
  search: '',
  SSNOption: LAST_4_DIGIT_KEY,
  planYear: FORFEITURE_GROUP_BY_PLAN_YEAR,
  groupBy: FORFEITURE_GROUP_BY_DEFAULT_VALUE,

  handleSetSSNOption: (value: OptionKey) =>
    set(() => ({
      SSNOption: value,
    })),
  handleSetSearch: (value: string) =>
    set(() => ({
      search: value,
    })),

  handleSetDetailedBy: (detailedBy: DetailedBy) => set(() => ({ detailedBy })),

  handleSetPlanYear: (value: OptionKey[]) =>
    set(() => ({
      planYear: value,
    })),

  handleSetGroupBy: (groupBy: OptionKey) =>
    set(() => ({
      groupBy,
    })),

  handleClear: () =>
    set(() => ({
      search: '',
      SSNOption: LAST_4_DIGIT_KEY,
      planYear: FORFEITURE_GROUP_BY_PLAN_YEAR,
      groupBy: FORFEITURE_GROUP_BY_DEFAULT_VALUE,
      detailedBy: DetailedBy.TRANSACTION,
    })),
}));
